import React, { useEffect, useState } from "react";
import { MapContainer, TileLayer, GeoJSON, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import { gardGeoJSON } from "./data/data_d_30";
import { bouchesDuRhoneGeoJSON } from "./data/data_d_13";
import { heraultGeoJSON } from "./data/data_d_34";
import { vaucluseGeoJSON } from "./data/data_d_84";

// Corriger le problème d'icône par défaut de Leaflet
const icon = L.icon({
  iconUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.3.1/images/marker-icon.png",
  iconRetinaUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.3.1/images/marker-icon-2x.png",
  shadowUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.3.1/images/marker-shadow.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});

// Définir les adresses des succursales
const addresses = [
  { position: [43.8374, 4.3601], name: "Succursale Nîmes" },
  { position: [43.9493, 4.8055], name: "Succursale Avignon" },
  { position: [43.6109, 3.8772], name: "Succursale Montpellier" },
  { position: [43.2965, 5.3698], name: "Succursale Marseille" },
];

const getColor = (code: string, isHovered: boolean) => {
  const colors: { [key: string]: [string, string] } = {
    "30": ["#0000FF", "#3333FF"],
    "84": ["#0000FF", "#3333FF"],
    "34": ["#0000FF", "#3333FF"],
    "13": ["#0000FF", "#3333FF"],
  };
  return colors[code][isHovered ? 1 : 0] || "#CCCCCC";
};

const InteractiveMap: React.FC = () => {
  const [map, setMap] = useState<L.Map | null>(null);
  const [coordinates, setCoordinates] = useState<
    { name: string; lat: number; lng: number; desc: string }[]
  >([]);
  useEffect(() => {
    if (map) {
      const gardBounds = L.geoJSON(gardGeoJSON).getBounds();
      const vaucluseBounds = L.geoJSON(vaucluseGeoJSON).getBounds();
      const heraultBounds = L.geoJSON(heraultGeoJSON).getBounds();
      const bouchesDuRhoneBounds = L.geoJSON(bouchesDuRhoneGeoJSON).getBounds();
      const bounds = gardBounds.extend(vaucluseBounds).extend(heraultBounds).extend(bouchesDuRhoneBounds);
      map.fitBounds(bounds);
    }
  }, [map]);
  useEffect(() => {
    // Récupérer les données depuis l'API REST WordPress
    const fetchCoordinates = async () => {
      try {
        const response = await fetch("/wp-json/interactive-map/v1/addresses");
        if (!response.ok) throw new Error("Erreur lors de la récupération des données");
        const data = await response.json();
        setCoordinates(data);
      } catch (error:unknown) {
        // @ts-ignore
        console.error(error.message);
      }
    };

    fetchCoordinates();
  }, []);
  const onEachFeature = (feature: any, layer: L.Layer) => {
    layer.on({
      mouseover: (e) => {
        const layer = e.target;
        layer.setStyle({
          weight: 3,
          fillOpacity: 0.7,
          fillColor: getColor(feature.properties.code, true),
        });
        layer.bringToFront();
      },
      mouseout: (e) => {
        const layer = e.target;
        layer.setStyle({
          weight: 2,
          fillOpacity: 0.2,
          fillColor: getColor(feature.properties.code, false),
        });
      },
    });
  };


  return (
    <MapContainer
      center={[43.9, 4.8]}
      zoom={8}
      style={{ height: "600px", width: "100%", borderRadius: "8px" }}
      // @ts-ignore
      whenReady={(e) => setMap(e.target)}
    >
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution="&copy; OpenStreetMap contributors"
      />
      <GeoJSON
        data={gardGeoJSON}
        style={() => ({
          color: "#0000FF",
          weight: 2,
          fillColor: "#0000FF",
          fillOpacity: 0.2,
        })}
        onEachFeature={onEachFeature}
      />
      <GeoJSON
        data={vaucluseGeoJSON}
        style={() => ({
          color: "#0000FF",
          weight: 2,
          fillColor: "#0000FF",
          fillOpacity: 0.2,
        })}
        onEachFeature={onEachFeature}
      />
      <GeoJSON
        data={heraultGeoJSON}
        style={() => ({
          color: "#0000FF",
          weight: 2,
          fillColor: "#0000FF",
          fillOpacity: 0.2,
        })}
        onEachFeature={onEachFeature}
      />
      <GeoJSON
        data={bouchesDuRhoneGeoJSON}
        style={() => ({
          color: "#0000FF",
          weight: 2,
          fillColor: "#0000FF",
          fillOpacity: 0.2,
        })}
        onEachFeature={onEachFeature}
      />
      {coordinates && coordinates.map((coord, index) => (
        // @ts-ignore
        <Marker key={index} position={[coord.lat, coord.lng]} icon={icon}>
          <Popup><strong>{coord.name}</strong>
            <p>{coord.desc}</p></Popup>
        </Marker>
      ))}
    </MapContainer>
  );
};

const App: React.FC = () => {
  return (
    <div className={"interactive_map_container"}>
      <InteractiveMap />
    </div>
  );
};

export default App;
